module.exports = __webpack_public_path__ + "img/exportWord.a44bf049.svg";